import { Connection } from './connection.model';

export class OutreachForm {
  public readonly form_data!: OutreachFormData;
  public readonly connections: Connection[] | null = null;
}

export class OutreachFormData {
  public readonly name?: string | null = null;
  public readonly email?: string | null = null;
  public outreach_type!: OutreachFormType;
  public wants_detailed_questionnaire?: boolean | null = null;
  public form_id?: string | null = null;
}

export enum OutreachFormType {
  PUBLIC = 0,
  CRF = 1,
  // DA = 2,  // No longer used
  GENERIC = 3,
  LOAN = 5,
}

export const OutreachFormTypes = [
  // {
  //   id: OutreachFormType.GENERIC,
  //   label: 'General Outreach Form',
  //   value: '3',
  // },
  {
    id: OutreachFormType.LOAN,
    label: 'Pre Lending Information Request',
    value: '5',
  },
];
